import { Grid2 } from '@mui/material';
import { useMemo, useState } from 'react';
import { mapScreenFormatTypeToScreenType } from '#helpers/enumMappers.ts';
import { disable as disableFullscreenLock } from '#helpers/fullscreenLock.ts';
import { getItemsKey } from '#helpers/getItemsKey.ts';
import { useToolbelt } from '#hooks/useToolbelt.ts';
import { type ActiveVideo } from '#types.ts';
import { Loader } from '../Loader/index.tsx';
import { PlayerSelectorModal } from '../Modal/PlayerSelectorModal.tsx';
import { Tile } from '../Tile/index.tsx';
import { type TileProps } from '../Tile/types.ts';
import { type TileGridProps } from './types.ts';

export const TileGrid = ({ hasNextPage, items = [], lastItemRef, loading, setActivePreview }: TileGridProps) => {
  const { uaParser } = useToolbelt();
  const [activeVideo, setActiveVideo] = useState<ActiveVideo | undefined>();
  const itemsKey = getItemsKey(items);

  const memoGrid = useMemo(
    () => (
      <Grid2 container spacing={2}>
        {items.map(({ id, title, ...rest }, index) => {
          const partialTileProps: Omit<TileProps, 'id' | 'title' | 'setActiveVideo'> = rest;

          if (index === items.length - 1) {
            partialTileProps.lastItemRef = lastItemRef;
          }

          return (
            <Grid2 key={`${String(id)}-${String(index)}`} size={{ lg: 2, md: 3, sm: 4, xs: 6 }}>
              <Tile
                id={id}
                setActivePreview={setActivePreview}
                setActiveVideo={setActiveVideo}
                title={title}
                {...partialTileProps}
              />
            </Grid2>
          );
        })}
      </Grid2>
    ),
    [itemsKey], // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <>
      {activeVideo?.src && activeVideo.src.length > 0 ? (
        <PlayerSelectorModal
          activeVideo={activeVideo}
          onClose={() => {
            setActiveVideo(undefined);
            void disableFullscreenLock(uaParser);
          }}
          type={mapScreenFormatTypeToScreenType(activeVideo.type)}
        />
      ) : undefined}
      {items.length > 0 ? memoGrid : undefined}
      {hasNextPage && loading && <Loader sx={{ marginTop: theme => theme.spacing(6) }} />}
    </>
  );
};
